import PropTypes from 'prop-types';
import React, { Component } from 'react';

import EMOJI_REACTIONS_MAP, { EMOJI_SIZES } from 'constants/emojiReactions';

import './styles.less';

export const emojiTypeToPath = {};

Object.keys(EMOJI_REACTIONS_MAP).forEach(key => {
  const type = EMOJI_REACTIONS_MAP[key];

  EMOJI_SIZES.forEach(size => {
    emojiTypeToPath[type] = require(`img/video-player/${type}${size}.png`);
  });
});

class Emoji extends Component {
  constructor(props) {
    super(props);

    this.onClick = this.onClick.bind(this);
  }

  onClick(event) {
    const rect = this.container.getBoundingClientRect();
    const type = this.props.type;
    const time = this.props.time;

    this.props.onClick({ type, rect, time, event });
  }

  render() {
    const { show = true, type, customAsset, dataTag } = this.props;

    const className = `emoji ${show ? 'show' : ''}`;

    // TODO: Investigate if we can remove wrapping DIV
    return (
      <div
        data-testid={dataTag}
        ref={ref => (this.container = ref)}
        className={className}
        onClick={this.onClick}
        onMouseDown={this.props.onMouseDown}
      >
        <img src={customAsset || emojiTypeToPath[type]} />
        {this.props.children}
      </div>
    );
  }
}

Emoji.propTypes = {
  type: PropTypes.oneOf(Object.values(EMOJI_REACTIONS_MAP).concat('custom'))
    .isRequired,
  onClick: PropTypes.func,
};

Emoji.defaultProps = {
  onClick() {},
};

export default Emoji;
